window.onload = () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    console.log("Reducing gsap motion based on your preferences");
  } else {

    const rootStyles = getComputedStyle(document.documentElement);
    const breakpoint_medium = parseFloat(rootStyles.getPropertyValue('--cve-breakpoint-md').trim());

    ScrollTrigger.defaults({
      markers: false,
      scrub: 1
    });

    let tweenVariables = {
      wax_x: "50vw",
      tools_x: "-50vw",
    }

    if (windowIsLessThan(breakpoint_medium)) {
      tweenVariables.wax_x = "100vw";
      tweenVariables.tools_x = "80vw";
    }

    // window.addEventListener('resize', calculateVariablesWithWidth(tweenVariables));

    // Initialize a timeline
    const tl = gsap.timeline();

    // Wax Items spinning in from the right
    tl.from(".wax-item", {
      scrollTrigger: {
        trigger: ".wax-column",
        id: "wax",
        start: "top 90%",
        end: "top 20%",
        scrub: 1.5
      },
      x: tweenVariables.wax_x,
      y: -200,
      rotation: 720,
      stagger: 0.1
    });

    // Tools shooting in from the left
    tl.from(".tool", {
      scrollTrigger: {
        trigger: ".tools-column",
        id: "tools",
        start: "top 75%",
        end: "top 45%",
        scrub: 1.5
      },
      x: tweenVariables.tools_x,
      stagger: 0.1
    });

    const windowHeight = window.innerHeight;
    tl.from(".grid-item", {
      scrollTrigger: {
        trigger: "#tmt-grid",
        id: "tmt-grid",
        start: "top bottom",
        end: "bottom 60%",
        scrub: 1.5
      },
      opacity: 0.2,
      y: windowHeight * 0.5,
      stagger: 0.1
    });
  }
}

function calculateVariablesWithWidth(tweenVariables)
{
  return tweenVariables
}

/**
 * @param width
 * @param orEqualTo
 * @return {boolean}
 */
function windowIsLessThan(width, orEqualTo = false)
{
  const windowWidth = window.innerWidth;
  if (orEqualTo === true) {
    return windowWidth <= width;
  } else {
    return windowWidth < width
  }
}

/**
 * @param width
 * @param orEqualTo
 * @return {boolean}
 */
function windowIsMoreThan(width, orEqualTo = false)
{
  const windowWidth = window.innerWidth;
  if (orEqualTo === true) {
    return windowWidth >= width;
  } else {
    return windowWidth > width
  }
}
